import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <footer className="bg-primary-50 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2 max-w-md">
            <Link to={`/${lang}`} className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-grid-line text-lg" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">{t('brand.name')}</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{t('footer.about')}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">
              <a href={`/${lang}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                {t('footer.quickLinks')}
              </a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to={`/${lang}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to={`/${lang}/spreadsheet-guide`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.articles')}
                </Link>
              </li>
              <li>
                <a href={`#qc`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.qc')}
                </a>
              </li>
              <li>
                <a href={`#shipping`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.shipping')}
                </a>
              </li>
              <li>
                <a href={`#faq`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.faq')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {t(c.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-4xl">{t('footer.disclaimer')}</p>
          <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} {t('brand.name')}. {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}